import { createContext } from "react";
import { initialEditingContext } from "../init";
const EditingContextCtx = createContext(initialEditingContext);

export default EditingContextCtx;
